import React from 'react';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';

import Tooltip from 'components/mui/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';

const MoveToBundle = ({ moveToBundleOptions }) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'LinkedMoveToBundleMenu',
  });

  const handleMenuItemClick = (action) => {
    action();
    popupState.close();
  };

  return (
    <>
      <Tooltip
        t={{
          id: 'tooltip.moveBundleTo',
          defaultMessage: 'Move bundle to',
        }}
      >
        <IconButton color="primary" {...bindTrigger(popupState)}>
          <ArrowRightAltOutlinedIcon color="primary" />
        </IconButton>
      </Tooltip>

      <Menu
        {...bindMenu(popupState)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {moveToBundleOptions.map((option) => (
          <MenuItem key={option.id} onClick={() => handleMenuItemClick(option.action)}>
            {option.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MoveToBundle;
